// The app's one API client, wired to the real transport: the runtime config's
// base URL, the Entra tokens and the browser's `fetch`. The class itself is
// `http.ts`; the local harness aliases this module and wires the same class to
// an in-process transport instead.

import { currentConfig, loadConfig } from './config'
import { apiToken, graphToken, initAuth, signIn } from './auth'
import type { ApiClient } from './contract'
import { HttpApiClient } from './http'

let instance: ApiClient | null = null

/** Boot order for the shell: read the runtime configuration, then complete or
    start sign-in. Anything after this may assume both. The local harness
    replaces this whole module, so its `bootstrap` is a no-op — that is how the
    mock runs with no Entra tenant and no API. */
export async function bootstrap(): Promise<void> {
  await loadConfig()
  const instance = await initAuth()
  if (!instance.getActiveAccount()) await signIn()
}

/** The single client instance the whole app shares. */
export function getClient(): ApiClient {
  instance ??= new HttpApiClient({
    apiBaseUrl: () => currentConfig().api_base_url,
    apiToken,
    graphToken,
    fetch: (url, init) => fetch(url, init),
  })
  return instance
}

/** Test seam: replace the implementation (the mock harness aliases this module
    wholesale, so this exists for unit tests that import the real one). */
export function setClient(client: ApiClient | null): void {
  instance = client
}

export type { ApiClient } from './contract'
